export function camelCaseToHyphenCase(str) {
  return str.split("").reduce((acc, letter) => {
    return letter.match(/([A-Z])/g)
      ? `${acc}-${letter.toLowerCase()}`
      : `${acc}${letter}`;
  });
}

export function hyphenCaseToCamelCase(str) {
  return str
    .split("-")
    .reduce(
      (acc, word) => `${acc}${word.charAt(0).toUpperCase()}${word.slice(1)}`
    );
}

const NON_DIGITS = /\D/g;
export const removeNonDigits = (input) => input.replace(NON_DIGITS, "");

// replaces fullwidth characters (U+FF0F-U+FF19) with ascii characters (U+002F-U+0039)
// ／０-９ -> /0-9
const FULLWIDTH_CHARS = /[\uff0f-\uff19]/g;
export const replaceFullwidthChars = (input) =>
  input.replace(FULLWIDTH_CHARS, (match) =>
    String.fromCharCode(match.charCodeAt(0) - 0xfee0)
  );

export const limitToLength = (length) => (input) => input.substring(0, length);

export function removeSpaces(s) {
  return s.replace(/ /g, "");
}

export const snakeCaseToText = (str) =>
  str ? capitalize(str.trim().replace(/_/g, " ")) : "";

const capitalize = (str) =>
  str.replace(/(?:^|\s)\S/g, (char) => char.toUpperCase());
